import React from "react";
import './Footer.css';

function Footer() {
    return <footer>
        <p><a href="https://www.linkedin.com/in/anirudhgupta905/">Connect @ Anirudh Gupta</a></p>
    </footer>
}

export default Footer;